import { ENV } from '../../../config/runtimeEnv';
import { createServiceClient } from '../../../lib/http/client';

const API_BASE_URL = `${ENV.VITE_HEALTHCARE_SERVER}/practitioner`;

export interface AppointmentTypeReminder {
	id: number;
	appointment_type_id: number;
	notification_template_id: number;
	remind_hours_before?: number;
	remind_days_before?: number;
	is_active: boolean;
	sort_order: number;
	created_at: string;
	updated_at: string;
}

export interface CreateReminderRequest {
	notification_template_id: number;
	remind_hours_before?: number;
	remind_days_before?: number;
	is_active?: boolean;
	sort_order?: number;
}

export interface UpdateReminderRequest {
	notification_template_id?: number;
	remind_hours_before?: number;
	remind_days_before?: number;
	is_active?: boolean;
	sort_order?: number;
}

export interface ReorderReminderRequest {
	reminders: Array<{ id: number; sort_order: number }>;
}

const api = () => {
	return createServiceClient({
		baseURL: API_BASE_URL,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const fetchAppointmentTypeReminders = async (
	appointmentTypeId: number
): Promise<AppointmentTypeReminder[]> => {
	const response = await api().get(`/appointment-types/${appointmentTypeId}/reminders`);
	return response.data.data || [];
};

export const createAppointmentTypeReminder = async (
	appointmentTypeId: number,
	data: CreateReminderRequest
): Promise<AppointmentTypeReminder> => {
	const response = await api().post(
		`/appointment-types/${appointmentTypeId}/reminders`,
		data
	);
	return response.data.data;
};

export const updateAppointmentTypeReminder = async (
	appointmentTypeId: number,
	reminderId: number,
	data: UpdateReminderRequest
): Promise<AppointmentTypeReminder> => {
	const response = await api().put(
		`/appointment-types/${appointmentTypeId}/reminders/${reminderId}`,
		data
	);
	return response.data.data;
};

export const deleteAppointmentTypeReminder = async (
	appointmentTypeId: number,
	reminderId: number
): Promise<void> => {
	await api().delete(`/appointment-types/${appointmentTypeId}/reminders/${reminderId}`);
};

export const reorderAppointmentTypeReminders = async (
	appointmentTypeId: number,
	data: ReorderReminderRequest
): Promise<void> => {
	await api().post(
		`/appointment-types/${appointmentTypeId}/reminders/reorder`,
		data
	);
};

export const toggleAppointmentTypeReminderActive = async (
	appointmentTypeId: number,
	reminderId: number
): Promise<AppointmentTypeReminder> => {
	const response = await api().patch(
		`/appointment-types/${appointmentTypeId}/reminders/${reminderId}/toggle-active`
	);
	return response.data.data;
};

export const fetchAvailableReminderTemplates = async (): Promise<any[]> => {
	const response = await api().get('/reminder-templates');
	const data = response.data;
	return Array.isArray(data) ? data : (data?.data ?? []);
};